export function _sortByFirstAndLastName(
  a: { firstName: string; lastName: string },
  b: { firstName: string; lastName: string },
): number {
  const nameForA = a.firstName + ' ' + a.lastName;
  const nameForB = b.firstName + ' ' + b.lastName;

  return nameForA.toLowerCase().localeCompare(nameForB.toLowerCase());
}
